var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgBharathpayTiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 258,
    height: 248,
    viewBox: "0 0 258 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213bc8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8370",
    "data-name": "Group 8370",
    transform: "translate(-14 -1153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7116",
    "data-name": "Group 7116",
    transform: "translate(-111 -37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2030",
    "data-name": "Rectangle 2030",
    transform: "translate(125 1190)",
    fill: "#6faa00",
    stroke: "rgba(33,33,33,0.1)",
    strokeWidth: 1,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179.148,
    height: 40,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 178.148,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Send_Money_Safely",
    "data-name": "Send Money Safely",
    transform: "translate(168 1214.852)",
    fill: "#212121",
    fontSize: 14,
    fontFamily: "JioType-Medium, JioType",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Send Money Safely")), /*#__PURE__*/React.createElement("g", {
    id: "Group_8365",
    "data-name": "Group 8365",
    transform: "translate(-7.852)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 15.5,
    cy: 15.556,
    rx: 15.5,
    ry: 15.556,
    transform: "translate(136.852 1194.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7490",
    "data-name": "Path 7490",
    d: "M3.6.712a2,2,0,0,1,3.07,0L9.8,4.457a2,2,0,0,1-1.54,3.274l-6.269.01A1.99,1.99,0,0,1,.46,4.472Z",
    transform: "translate(144.301 1211.564) rotate(-60)",
    fill: "#369b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7164",
    "data-name": "Path 7164",
    d: "M2.53.289a.818.818,0,0,1,1.255,0l2.335,2.8A.817.817,0,0,1,5.49,4.424L.811,4.431A.813.813,0,0,1,.186,3.1Z",
    transform: "translate(152.392 1213.965) rotate(-60)",
    fill: "#369b00",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7112",
    "data-name": "Group 7112",
    transform: "translate(-51 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2030-2",
    "data-name": "Rectangle 2030",
    transform: "translate(125 1190)",
    fill: "#0e1aaa",
    stroke: "rgba(33,33,33,0.1)",
    strokeWidth: 1,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 40,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 197,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Request_money_easily",
    "data-name": "Request money easily",
    transform: "translate(238 1214.852)",
    fill: "#212121",
    fontSize: 14,
    fontFamily: "JioType-Medium, JioType",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -68.649,
    y: 0
  }, "Request money easily")), /*#__PURE__*/React.createElement("g", {
    id: "Group_8364",
    "data-name": "Group 8364",
    transform: "translate(-7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139-2",
    "data-name": "Ellipse 139",
    cx: 15.556,
    cy: 15.556,
    r: 15.556,
    transform: "translate(136.852 1194.444)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_25",
    "data-name": "Polygon 25",
    d: "M5.871,1.844a2,2,0,0,1,3.073,0l3.137,3.765a2,2,0,0,1-1.536,3.28H4.27a2,2,0,0,1-1.536-3.28Z",
    transform: "translate(158.895 1206.423) rotate(135)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7165",
    "data-name": "Path 7165",
    d: "M2.995.348a.966.966,0,0,1,1.485,0L7.248,3.67a.966.966,0,0,1-.742,1.585H.968A.966.966,0,0,1,.226,3.67Z",
    transform: "translate(151.164 1213.804) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7115",
    "data-name": "Group 7115",
    transform: "translate(-111 67)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2030-3",
    "data-name": "Rectangle 2030",
    width: 168.148,
    height: 40,
    rx: 20,
    transform: "translate(125 1190)",
    fill: "#f7bb06",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Recharge_quickly",
    "data-name": "Recharge quickly",
    transform: "translate(166.481 1214.852)",
    fill: "#212121",
    fontSize: 14,
    fontFamily: "JioType-Medium, JioType",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Recharge quickly")), /*#__PURE__*/React.createElement("g", {
    id: "Group_8366",
    "data-name": "Group 8366",
    transform: "translate(129.444 1194.444)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139-3",
    "data-name": "Ellipse 139",
    cx: 15.556,
    cy: 15.556,
    r: 15.556,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7142",
    "data-name": "Path 7142",
    d: "M3.592-17.2a.674.674,0,0,0-.233-.263.59.59,0,0,0-.334-.1H-1.188l1.3-6.2a.58.58,0,0,0-.051-.435.6.6,0,0,0-.334-.294.673.673,0,0,0-.446-.01.6.6,0,0,0-.344.273L-7.528-13.753a.544.544,0,0,0-.1.324.642.642,0,0,0,.081.324.642.642,0,0,0,.233.233.637.637,0,0,0,.334.091h4.172L-4.064-7.19a.658.658,0,0,0,.041.456.556.556,0,0,0,.324.294.8.8,0,0,0,.122.03.738.738,0,0,0,.122.01.6.6,0,0,0,.3-.081A.762.762,0,0,0-2.91-6.7l6.461-9.884a.405.405,0,0,0,.111-.273A.651.651,0,0,0,3.592-17.2Z",
    transform: "translate(16.052 31.586)",
    fill: "#f7bb06",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7141",
    "data-name": "Path 7141",
    d: "M3.592-17.2a.674.674,0,0,0-.233-.263.59.59,0,0,0-.334-.1H-1.188l1.3-6.2a.58.58,0,0,0-.051-.435.6.6,0,0,0-.334-.294.673.673,0,0,0-.446-.01.6.6,0,0,0-.344.273L-7.528-13.753a.544.544,0,0,0-.1.324.642.642,0,0,0,.081.324.642.642,0,0,0,.233.233.637.637,0,0,0,.334.091h4.172L-4.064-7.19a.658.658,0,0,0,.041.456.556.556,0,0,0,.324.294.8.8,0,0,0,.122.03.738.738,0,0,0,.122.01.6.6,0,0,0,.3-.081A.762.762,0,0,0-2.91-6.7l6.461-9.884a.405.405,0,0,0,.111-.273A.651.651,0,0,0,3.592-17.2Z",
    transform: "translate(17.533 30.804)",
    fill: "#ffba00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7113",
    "data-name": "Group 7113",
    transform: "translate(-111 171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2030-4",
    "data-name": "Rectangle 2030",
    transform: "translate(125 1190)",
    fill: "#f15725",
    stroke: "rgba(33,33,33,0.1)",
    strokeWidth: 1,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.963,
    height: 40,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173.963,
    height: 39,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Pay_stores_smartly",
    "data-name": "Pay stores smartly",
    transform: "translate(168.889 1214.852)",
    fill: "#212121",
    fontSize: 14,
    fontFamily: "JioType-Medium, JioType",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pay stores smartly")), /*#__PURE__*/React.createElement("g", {
    id: "Group_8369",
    "data-name": "Group 8369",
    transform: "translate(129.444 1194.444)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139-4",
    "data-name": "Ellipse 139",
    cx: 15.556,
    cy: 15.556,
    r: 15.556,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M5.186,11.853H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H12.815a2,2,0,0,1,2,2V9.852a2,2,0,0,1-2,2H10.371V7.037a2.592,2.592,0,1,0-5.185,0v4.815Z",
    transform: "translate(8.148 11.111)",
    fill: "#ffbf69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7143",
    "data-name": "Path 7143",
    d: "M154.69,1210.965s2.041,3.333,4.19,0c.327.233.4.71.817,1.078a2.28,2.28,0,0,0,2.734,0c.173-.108.317-.5.965-1.078a2.929,2.929,0,0,0,1.926,1.534,2.285,2.285,0,0,0,2.057-.981c.553-1.109-.616-2.7-.616-2.7l-.541-1.221s-.148-.879-1.957-.879H153.087s-1.277.178-1.613.879a27.764,27.764,0,0,0-.913,2.7,1.9,1.9,0,0,0,1.933,2.32C154.907,1212.882,154.69,1210.965,154.69,1210.965Z",
    transform: "translate(-143.469 -1198.779)",
    fill: "#f52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2091",
    "data-name": "Rectangle 2091",
    d: "M2.593,0h0A2.593,2.593,0,0,1,5.185,2.593V7.407a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.593A2.593,2.593,0,0,1,2.593,0Z",
    transform: "translate(149.444 1210)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7114",
    "data-name": "Group 7114",
    transform: "translate(-51 119)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2030-5",
    "data-name": "Rectangle 2030",
    width: 154.074,
    height: 40,
    rx: 20,
    transform: "translate(125 1190)",
    fill: "#a852de",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Pay_bills_timely",
    "data-name": "Pay bills timely",
    transform: "translate(166.481 1214.852)",
    fill: "#212121",
    fontSize: 14,
    fontFamily: "JioType-Medium, JioType",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pay bills timely")), /*#__PURE__*/React.createElement("g", {
    id: "Group_8368",
    "data-name": "Group 8368",
    transform: "translate(129.444 1194.444)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139-5",
    "data-name": "Ellipse 139",
    cx: 15.556,
    cy: 15.556,
    r: 15.556,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8367",
    "data-name": "Group 8367",
    transform: "translate(8.418 6.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2087",
    "data-name": "Rectangle 2087",
    d: "M.7,0,4.181,0A.657.657,0,0,1,4.452.06a.7.7,0,0,1,.221.159.746.746,0,0,1,.149.235.787.787,0,0,1,0,.576.746.746,0,0,1-.149.235.7.7,0,0,1-.221.159.657.657,0,0,1-.271.058H.7a.66.66,0,0,1-.272-.058A.7.7,0,0,1,.2,1.266a.747.747,0,0,1-.15-.236.787.787,0,0,1,0-.578A.747.747,0,0,1,.2.217.7.7,0,0,1,.426.058.66.66,0,0,1,.7,0Z",
    transform: "translate(3.985 11.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2086",
    "data-name": "Rectangle 2086",
    d: "M.7,0,6.971,0a.656.656,0,0,1,.27.058A.7.7,0,0,1,7.463.22a.746.746,0,0,1,.149.235.787.787,0,0,1,0,.576.746.746,0,0,1-.149.235.7.7,0,0,1-.221.159.656.656,0,0,1-.27.058H.7a.662.662,0,0,1-.272-.058A.7.7,0,0,1,.2,1.267a.748.748,0,0,1-.15-.236.787.787,0,0,1,0-.578A.747.747,0,0,1,.2.218.7.7,0,0,1,.427.059.662.662,0,0,1,.7,0Z",
    transform: "translate(4.068 3.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2084",
    "data-name": "Rectangle 2084",
    d: "M1.924.009,10.865.05a1.835,1.835,0,0,1,.743.16,1.921,1.921,0,0,1,.606.431,2.02,2.02,0,0,1,.409.637,2.077,2.077,0,0,1,.15.778V15.811a2.074,2.074,0,0,1-.15.778,2.013,2.013,0,0,1-.409.636,1.914,1.914,0,0,1-.606.429,1.832,1.832,0,0,1-.743.159l-8.941.02a1.847,1.847,0,0,1-.749-.156,1.919,1.919,0,0,1-.612-.429,2.011,2.011,0,0,1-.412-.637A2.072,2.072,0,0,1,0,15.83V2.007a2.069,2.069,0,0,1,.151-.78A2,2,0,0,1,.564.59,1.913,1.913,0,0,1,1.175.163,1.844,1.844,0,0,1,1.924.009Z",
    transform: "translate(-0.007 -0.01)",
    fill: "#a44fd8",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2085",
    "data-name": "Rectangle 2085",
    d: "M1.924.009,10.865.05a1.835,1.835,0,0,1,.743.16,1.921,1.921,0,0,1,.606.431,2.02,2.02,0,0,1,.409.637,2.077,2.077,0,0,1,.15.778V15.811a2.074,2.074,0,0,1-.15.778,2.013,2.013,0,0,1-.409.636,1.914,1.914,0,0,1-.606.429,1.832,1.832,0,0,1-.743.159l-8.941.02a1.847,1.847,0,0,1-.749-.156,1.919,1.919,0,0,1-.612-.429,2.011,2.011,0,0,1-.412-.637A2.072,2.072,0,0,1,0,15.83V2.007a2.069,2.069,0,0,1,.151-.78A2,2,0,0,1,.564.59,1.913,1.913,0,0,1,1.175.163,1.844,1.844,0,0,1,1.924.009Z",
    transform: "translate(1.474 0.731)",
    fill: "#aa53e0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBharathpayTiles);
export default __webpack_public_path__ + "static/media/bharathpay-tiles.42f70f4d18f01de5afa99783d9364618.svg";
export { ForwardRef as ReactComponent };